import { useMutation } from '@tanstack/react-query';
import { updateAddress } from '@/lib/api/settings';
import type { AddressFormData } from '@/features/email-flows/validations/address';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';

export const useAddress = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: (data: AddressFormData) => updateAddress(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending };
};
